import React from "react";
import { useLanguage } from "../context/LanguageContext";

const StatsBar = () => {
  const { t } = useLanguage();
  return (
    <section data-testid="stats-bar" className="relative bg-[#0F0F0F] border-t border-[#B08D57]/20">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-20">
        <div className="grid grid-cols-2 lg:grid-cols-4 divide-y lg:divide-y-0 lg:divide-x divide-white/8">
          {t.stats.items.map((s, i) => (
            <div
              key={i}
              data-testid={`stat-${i}`}
              className="py-10 lg:py-12 px-2 lg:px-8 text-center group hover:bg-white/[0.02] transition-colors duration-500"
            >
              <div className="font-display-thin text-white text-4xl sm:text-5xl lg:text-[58px] leading-none tracking-tight group-hover:text-[#B08D57] transition-colors">
                {s.v}
              </div>
              <div className="mt-4 overline text-white/55">{s.l}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsBar;
